import { ManagersModuleBase } from "Managers/ManagersModuleBase";
import { WeeklyRotaSessionReportViewModel } from "../WeeklyRotaSessionReportViewModel";
import { StudentSessionReportManagersConfig } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { AppUrls } from "AppUrls";
import { APIManager, CommandsManager, DomainManager, MobXManager } from "Views/Students/Student/StudentReports/Form/Managers";

/** Config for Mentor/WeeklyRota flow */
const WEEKLY_ROTA_CONFIG: StudentSessionReportManagersConfig = {
    getNavigationConfirmPath: () => AppUrls.Client.Admin.Mentor.WeeklyRota,
    getCancelPath: (vm) => AppUrls.Client.Students.Student.StudentReports.Edit.replace(":id", vm.model.id ?? vm.model.studentId ?? ""),
    isAdmin: false,
    showExport: false,
};

/**
 * Orchestrates manager instances for WeeklyRotaSessionReportViewModel.
 * Uses the same managers as SessionReport with Mentor-specific config.
 */
export class WeeklyRotaManagersModule extends ManagersModuleBase<WeeklyRotaSessionReportViewModel> {
    public commands!: CommandsManager;
    public mobx!: MobXManager;
    public api!: APIManager;
    public domain!: DomainManager;
    public config: StudentSessionReportManagersConfig;

    constructor(viewModel: WeeklyRotaSessionReportViewModel) {
        super(viewModel);
        this.config = WEEKLY_ROTA_CONFIG;
        this.viewMode.setViewMode(viewModel.reportId ? "edit" : "add");
        this.createManagers();
    }

    protected createManagers(): void {
        this.mobx = new MobXManager(this.viewModel);
        this.domain = new DomainManager(this.viewModel, this.config);
        this.api = new APIManager(this.viewModel);
        this.commands = new CommandsManager(this.viewModel, this.config);
    }
}
